import { PayPalButtons } from "@paypal/react-paypal-js";
import { useNavigate } from "react-router-dom";
const BASE_URL = process.env.REACT_APP_BASE_URL;

const PayPalIntegration = ({ currentCourse }) => {
   const navigate = useNavigate();
 const createOrder = async () => {
 try {
  const response = await fetch(`${BASE_URL}/paypal/create-paypal-order/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      "x-api-key": process.env.REACT_APP_X_API_KEY
    },
    body: JSON.stringify({
      cart: [
        {
          id: currentCourse?.id,
          name: currentCourse?.name,
          description: currentCourse?.description,
          category: currentCourse?.category_name,
          subcategory: currentCourse?.subcategory_name,
          quantity: 1,
          price: currentCourse?.price,
          learning_type:
            currentCourse?.learning_type === 1 ? "course" :
            currentCourse?.learning_type === 2 ? "video" :
            currentCourse?.learning_type === 3 ? "audio" :
            currentCourse?.learning_type === 4 ? "podcast" :
            "course"
        },
      ],
    }),
  });

    const order = await response.json();

    if (!order.id) {
      throw new Error("No order ID returned from backend");
    }

    console.log("Order ID:", order.id);
    return order.id;
  } catch (error) {
    console.error("Error creating PayPal order:", error);
  }
};






 

//   try {
//     // Capture the order
//     const response = await fetch(`${BASE_URL}/paypal/capture-paypal-order`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//       },
//       body: JSON.stringify({ orderID: data?.orderID }),
//     });

//     const orderData = await response.json();

//     // Trigger the webhook manually
//     const webhookResponse = await fetch(`${BASE_URL}/paypal/webhook`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ orderID: data?.orderID, payer: orderData.payer }),
//     });

//     if (webhookResponse.ok) {
//       // Success: navigate to student page
//       alert(`Transaction completed by ${orderData.payer.name.given_name}`);
//       navigate("/student");
//     } else {
//       // Webhook failed
//       const errorData = await webhookResponse.json();
//       alert(`Issue processing payment: ${errorData.msg || "Unknown error"}`);
//     }
//   } catch (error) {
//     console.error("Error:", error);
//     alert("There was an error completing the transaction.");
//   }
// };

const onApprove = async (data) => {
  try {
    // Capture the order
    const response = await fetch(`${BASE_URL}/paypal/capture-paypal-order/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "x-api-key": process.env.REACT_APP_X_API_KEY
      },
      body: JSON.stringify({ orderID: data?.orderID }),
    });

    const orderData = await response.json();

   if (orderData.success) {
  // Show alert after 3 seconds
  setTimeout(() => {
    alert(`Transaction completed by ${orderData.payer.name.given_name}`);
  }, 3000);

  // Navigate after 5 seconds
  setTimeout(() => {
    navigate("/student");
  }, 5000);
} else {
  alert(`Payment failed: ${orderData.msg}`);
}


  } catch (error) {
    console.error("Error:", error);
    alert("There was an error completing the transaction.");
  }
};


  return (
    <div>
      <PayPalButtons createOrder={createOrder} onApprove={onApprove}  />
    </div>
  );
};

export default PayPalIntegration;
